import { IPostProductDto } from 'appDtos';
import React, { useState } from 'react';
import Alert, { AlertType } from '../../../Shared/components/Alert';
import ControlInputField from '../../../Shared/components/ControlInputField';
import { hasValue } from '../../../Shared/components/validators';
import useApi from '../../../Shared/hooks/useApi';
import { useApiHandleError } from '../../../Shared/hooks/useApiHandleError';
import useFormProcessor from '../../../Shared/hooks/useFormProcessor';

export function CreateProduct() {
    const axios = useApi();
    const [success, setSuccess] = useState(false);
    const { setError, errorMessage } = useApiHandleError();

    const {
        handleOnChange, handleFieldError, setIsProcessing, reset, formData, isProcessing, hasError } = useFormProcessor<IPostProductDto>({ name: '', unitOfMeasure: '' }, { name: false, unitOfMeasure: false, categoryId: false });

    const handleSubmit = async () => {
        setIsProcessing(true);

        try {
            const response = await axios.post('Product', { product: formData });
            if (response?.data) {
                reset();
                setSuccess(true);
            }
        } catch (error: any) {
            setError(error);
        }
        setIsProcessing(false);
    };

    return (
        <div className="">
            {!!errorMessage && <Alert type={AlertType.DANGER} message={errorMessage} />}
            {success && <Alert type={AlertType.SUCCESS} message="Product successfully added." />}
            <form className="p-3">
                <ControlInputField
                    onChange={handleOnChange}
                    autoComplete="off"
                    onFieldError={handleFieldError}
                    label="Product Name"
                    placeholder="Enter prouct's name."
                    id="name"
                    value={formData.name}
                    name="name"
                    focusOnMount={true}
                    type="text"
                    required={true}
                    validationFunction={hasValue} />
                <ControlInputField
                    onChange={handleOnChange}
                    autoComplete="off"
                    onFieldError={handleFieldError}
                    label="Unit of measure"
                    placeholder="Enter unit of measure."
                    id="unitOfMeasure"
                    value={formData.unitOfMeasure}
                    name="unitOfMeasure"
                    type="text"
                    required={true}
                    validationFunction={hasValue} />
            </form>
            <button onClick={handleSubmit} type="button" disabled={isProcessing || hasError} className="btn btn-warning">Submit</button>
        </div>
    );
}


